import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalvideoabandoned-card',
  templateUrl: './helpbutton-reports-totalvideoabandoned-card.component.html',
  styleUrls: ['./helpbutton-reports-totalvideoabandoned-card.component.scss']
})
export class HelpbuttonReportsTotalvideoabandonedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
